import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { rutaEscuela } from '../rutas-escuela';
import { SesionAlumnoService } from '../services/sesion-alumno.service';

// Rutas del área del alumno (mi aprendizaje, aula...). Sin sesión vigente manda a ingresar y recuerda a
// dónde volver. Es solo comodidad de navegación: la seguridad real está en el backend (AlumnoGuard +
// matrícula vigente por curso), que responde 401/403 aunque este guard se saltara.
export const alumnoGuard: CanActivateFn = (_route, state) => {
  if (inject(SesionAlumnoService).token) {
    return true;
  }
  return inject(Router).createUrlTree(rutaEscuela('ingresar'), { queryParams: { volver: state.url } });
};
